var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.115,
    height: 19.828,
    viewBox: "0 0 21.115 19.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(0 -1.242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 6.162,
    height: 19.828,
    transform: "translate(7.414 1.242)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 6.162,
    height: 14.058,
    transform: "translate(14.953 7.012)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 6.162,
    height: 8.204,
    transform: "translate(0 12.866)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIc);
export default __webpack_public_path__ + "static/media/stats-ic.f59b96c781c0e3cfc02bc23b1dcfd1fc.svg";
export { ForwardRef as ReactComponent };